// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"31ce74d9","977":"9138f30d"}[chunkId] + ".chunk.js";
};